import { GridColDef } from "@mui/x-data-grid";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const CounsellorAvailabilityTableElements: GridColDef[] = [
  {
    field: "id",
    headerName: "ID",
    width: 100,
    headerClassName: "header--bg",
  },
  {
    field: "mentorId",
    headerName: "Mentor Id",
    width: 100,
    headerClassName: "header--bg",
  },
  {
    field: "time",
    headerName: "Number of times available",
    width: 200,
    headerClassName: "header--bg",

    renderCell: (params: any) => (
      <>
        {params?.row?.time.value || ""} {params?.row?.time.unit || ""}
      </>
    ),
  },

  {
    field: "daysDate",
    headerName: "Days Date",
    width: 200,
    headerClassName: "header--bg",
    valueGetter: (params: any) =>
      params?.value ? (params?.value as string[]).join(", ") : "",
  },
  {
    field: "startTime",
    headerName: "Start Time",
    width: 100,
    headerClassName: "header--bg",
  },
  {
    field: "endTime",
    headerName: "End Time",
    width: 100,
    headerClassName: "header--bg",
  },

  {
    field: "actions",
    headerName: "Actions",
    headerClassName: "header--bg",
    width: 300,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => {
      console.log("params", params);
      return (
        <div>
          {/* <AddSlot mentorID={params?.row?.id} /> */}
          <Link
            to={`/e-counselling/counsellor-availability-profile/${params?.row?.mentorId}`}
          >
            <Button
              variant="light"
              className="rounded-5 "
              style={{
                fontSize: "12px",
                background: "rgba(25, 22, 29, 0.06)",
              }}
            >
              View Counsellor profile
            </Button>
          </Link>
        </div>
      );
    },
  },
];

export default CounsellorAvailabilityTableElements;
